import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import JDRepository from './pages/JDRepository';
import Schedule from './pages/Schedule';
import Interview from './pages/Interview';
import Results from './pages/Results';
import VendorSourcing from './pages/VendorSourcing';
import CandidateAuth from './pages/CandidateAuth';
import CandidateDashboard from './pages/CandidateDashboard';
import DashboardLayout from './layouts/DashboardLayout';
import Report from './pages/Report';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';

// 🔥 NEW IMPORTS
import Landing from './pages/Landing';
import Blogs from './pages/Blogs';
import Contact from './pages/Contact';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default function App() {
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    window.location.href = '/login'; 
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* ========================================== */}
        {/* PUBLIC WEBSITE ROUTES                      */}
        {/* ========================================== */}
        <Route path="/" element={<Landing />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact" element={<Contact />} />

        {/* ========================================== */}
        {/* AUTH ROUTES                                */}
        {/* ========================================== */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        
        {/* ========================================== */}
        {/* CANDIDATE ROUTES (Isolated from Recruiters)*/}
        {/* ========================================== */}
        <Route path="/candidate-login" element={<CandidateAuth />} />
        <Route path="/candidate-portal" element={<CandidateDashboard />} />
        <Route path="/interview/:session_id" element={<Interview />} />

        {/* ========================================== */}
        {/* RECRUITER PROTECTED ROUTES (Dashboard)     */}
        {/* ========================================== */}
        <Route element={
          <ProtectedRoute>
            <DashboardLayout onLogout={handleLogout} />
          </ProtectedRoute>
        }>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/jd" element={<JDRepository />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/results" element={<Results />} />
          <Route path="/vendor-sourcing" element={<VendorSourcing />} />
          <Route path="/vendor-sourcing/jd/:jdId" element={<VendorSourcing />} />
          <Route path="/vendor-sourcing/jd/:jdId/assign" element={<VendorSourcing />} />
          <Route path="/vendor-sourcing/jd/:jdId/resumes" element={<VendorSourcing />} />
          <Route path="/vendor-sourcing/jd/:jdId/rank" element={<VendorSourcing />} />
          <Route path="/report/:session_id" element={<Report />} />
        </Route>

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}